import { axiosInstance as axiosAssembly } from '../../boot/axios-assembly'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 獲取需要添加工單訂單信息
    GetOrderInfo({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('GetOrderInfo', {
          OrderId: request.OrderId
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 獲取工班主管
    GetWorkMasterList({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('GetWorkMasterList')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 获取业务人员的信息
    BusinessList({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('BusinessList')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 添加工班項目
    SetAssemblyOrder({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('SetAssemblyOrder', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve()
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 导出工班订单
    ExportAssemblyOrderExcel({ commit, rootGetters }, request) {
      return axiosAssembly
        .post(
          'ExportAssemblyOrderExcel',
          {
            ...request
          },
          { responseType: 'blob' }
        )
        .then((response) => {
          return Promise.resolve(response.data)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 獲取工班項目數據列表
    GetAssemblyOrderList({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('GetAssemblyOrderList', {
          ...request
        })
        .then((response) => {
          return Promise.resolve(response.data.Values)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 獲取工班項目數據列表
    GetAssemblyOrderInfo({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('GetAssemblyOrderInfo', {
          AssemblyOrderId: request.AssemblyOrderId
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 獲取滿意度調查工班列表
    GetSatisfactionFinish({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('GetSatisfactionFinish', {
          ...request
        })
        .then((response) => {
          return Promise.resolve(response.data.Values)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 獲取滿意度調查問題表
    GetSatisfactionAnswer({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('GetSatisfactionAnswer', {
          ...request
        })
        .then((response) => {
          return Promise.resolve(response.data.Values)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    //代工 快客 查看工班信息
    GetQuickOemOrderApplyAss({ rootGetters }, request) {
      return axiosAssembly
        .get(`GetQuickOemOrderApplyAss?assOrderId=${request.assOrderId}`)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //快客代工 编辑 工班项目
    EditApplyAssemblyOrder({ rootGetters }, request) {
      return axiosAssembly
        .post('EditApplyAssemblyOrder', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 網頁 設置司機派工
    SetDistributionDirverCar({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('SetDistributionDirverCar', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 網頁 刪除司機派工
    DeleteDistributionDirverCar({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('DeleteDistributionDirverCar', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 網頁 設置組裝派工
    SetDistributionWorker({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('SetDistributionWorker', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 網頁 刪除組裝派工
    DeleteDistributionWorker({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('DeleteDistributionWorker', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //获取工班派车组装信息
    GetDistributionDirverWorkerList({ rootGetters }, request) {
      return axiosAssembly
        .get(`GetDistributionDirverWorkerList?assemblyOrderId=${request.assemblyOrderId}`)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CancelAssemblyOrder({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('CancelAssemblyOrder', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddDriver({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('AddDriver', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    }
  }
}
